<section class="widget">
  <h2>{{ title }}</h2>
  <p class="intro">
    Evaluation runs from the last 30 days. Select a completed run to load its
    results.
  </p>
  @if (loading) {
    <app-loading-state></app-loading-state>
  } @else if (error) {
    <app-error-state [message]="error"></app-error-state>
  } @else if (!runs.length) {
    <app-empty-state message="No evaluation runs were found."></app-empty-state>
  } @else {
    <div class="runs">
      @for (run of visibleRuns; track run.runId || $index) {
        <button
          class="run"
          [disabled]="!isCompleted(run)"
          (click)="select(run)"
          matTooltip="Only completed runs can load evaluation results"
        >
          <span
            ><strong>{{ run.runId }}</strong
            ><small
              >{{ run.periodStart || '—' }} to {{ run.periodEnd || '—' }} ·
              {{ run.sourceCount || 0 }} source records</small
            ></span
          ><span class="status" [class.pending]="!isCompleted(run)">{{
            run.status
          }}</span>
        </button>
      }
    </div>
    @if (runs.length > initialLimit) {
      <div class="actions">
        <button
          mat-stroked-button
          type="button"
          class="toggle-runs-btn"
          (click)="toggleShowAll()"
          [attr.aria-expanded]="showAll"
        >
          <mat-icon>{{ showAll ? 'expand_less' : 'expand_more' }}</mat-icon>
          {{
            showAll
              ? 'Show fewer runs'
              : 'See more evaluation runs (' +
                (runs.length - initialLimit) +
                ' more)'
          }}
        </button>
      </div>
    }
  }
  @if (selected) {
    <div class="details">
      <strong>Selected run:</strong> {{ selected.runId
      }}<span>
        · Boilers included: {{ selected.includeBoilers ? 'Yes' : 'No' }}</span
      >
      @if (isCompleted(selected)) {
        <span class="details-hint">Evaluation results are loading below.</span>
      }
    </div>
  }
</section>
